import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import * as formNormalizers from '../../app/services/form-normalizers';
import appSettings from '../../app/reducers/app-settings';
import commonSettings from '../../app/reducers/common-settings';
import auth from '../../app/reducers/auth';
import headerWidget from '../../app/reducers/header-widget';
import commentForm from '../../app/reducers/comment-form';
import comments from '../../app/reducers/comments';
import communitiesContext from '../../app/reducers/communities-context';
import postEditor from '../../app/reducers/post-editor';
import commentEdit from '../../app/reducers/edited-comment-id';
import experiments from '../../app/reducers/experiments';
import appData from '../../app/reducers/app-data';
import header from '../../app/reducers/header';
import isAppLoaded from '../../app/reducers/is-app-loaded';
import isDemoMode from '../../app/reducers/is-demo-mode';
import isLoaded from '../../app/reducers/is-loaded';
import isLoading from '../../app/reducers/is-loading';
import isPostInPreview from '../../app/reducers/is-post-in-preview';
import lastPostSlug from './last-post-slug';
import locale from '../../app/reducers/locale';
import locationHistory from '../../app/reducers/location-history';
import members from '../../app/reducers/members';
import message from '../../app/reducers/message';
import modal from '../../app/reducers/modal';
import pagination from '../../app/reducers/pagination';
import posts from '../../app/reducers/posts';
import profileForm from '../../app/reducers/profile-form';
import recentPostsIds from '../../app/reducers/recent-posts-ids';
import search from '../../app/reducers/search';
import searchInput from '../../app/reducers/search-input';
import searchParams from '../../app/reducers/search-params';
import siteInfo from '../../app/reducers/site-info';
import sitePages from '../../app/reducers/site-pages';
import rceSettings from '../../app/reducers/rce-settings';
import categories from '../../app/reducers/categories';
import typing from '../../app/reducers/typing';
import users from '../../app/reducers/users';
import userAgent from '../../app/reducers/user-agent';
import userStats from '../../app/reducers/user-stats';
import viewMode from '../../app/reducers/view-mode';
import writers from '../../app/reducers/writers';
import contentMigration from '../../content-migration/reducers/content-migration-status';

export default combineReducers({
  appSettings,
  commonSettings,
  auth,
  headerWidget,
  comments,
  communitiesContext,
  commentEdit,
  contentMigration,
  postEditor,
  experiments,
  appData,
  header,
  isAppLoaded,
  isDemoMode,
  isLoaded,
  isLoading,
  isPostInPreview,
  lastPostSlug,
  loadingBar: loadingBarReducer,
  locale,
  locationHistory,
  members,
  message,
  modal,
  pagination,
  posts,
  routing: routerReducer,
  recentPostsIds,
  search,
  searchInput,
  searchParams,
  siteInfo,
  sitePages,
  rceSettings,
  categories,
  typing,
  users,
  userAgent,
  userStats,
  viewMode,
  writers,
  form: formReducer
    .plugin({
      comment: commentForm,
      profile: profileForm,
    })
    .normalize(formNormalizers),
});
